import {UPDATE_FETCHING} from 'ducks/propertyDetail';

function updateFetching({fetching = {}} = {}) {
  return (dispatch) => {
    if (!fetching || typeof fetching === 'string') {
      return Promise.reject('Fetching field should be an object');
    }
    const payload = { fetching };
    return dispatch({type: UPDATE_FETCHING, payload});
  };
}

const propertyDetailActions = {
  updateFetching,
};

export default propertyDetailActions;
